<template>
  <v-card
    v-if="shouldRender"
    :aria-label="$bct('Reasons for review')"
    elevation="1"
    border
    tile
  >
    <template #title>
      <h5>{{ $bct('Reasons for review') }}</h5>
    </template>

    <template #text>
      <div class="rule-set-results-content">
        <RuleResultItem
          v-for="result in failedResults"
          :key="result.message"
          :result="result"
        />
      </div>
    </template>
  </v-card>
</template>

<script setup>
import { toRef } from 'vue';

import RuleResultItem from '@/shared/components/rule-set-results/RuleResultItem.vue';
import useRuleSetResults from '@/shared/composables/useRuleSetResults';

const props = defineProps({
  ruleSetResult: {
    type: Object,
    default: null,
  },
  invoice: {
    type: Object,
    default: null,
  },
});

const $bct = inject('translator');

const { failedResults, hasFailedResults } = useRuleSetResults(toRef(props, 'ruleSetResult'));

const shouldRender = computed(() => {
  return hasFailedResults.value && props.invoice?.status === 'needs_review';
});
</script>

<style scoped>
.rule-set-results-content {
  display: flex;
  flex-direction: column;
  gap: 0;
}
</style>
